const classPrefix = 'result-conspect';
const dataPrefix = 'data-result-conspect';
const $container = document.querySelector(`[${dataPrefix}]`);

if ($container) {
    resultConspect({$container});
}

export function resultConspect({$container}) {
    const header = $container.querySelector(
        `[${dataPrefix}-header]`
    );
    const body = $container.querySelector(
        `[${dataPrefix}-body]`
    );

    const downloadBtn = header.querySelector(`.${classPrefix}__download-btn`);
    if (downloadBtn) {
        downloadBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            // при необходимости здесь можно дополнительно что-то делать
        });
    }

    header.addEventListener('click', () => {
        const isActive = $container.classList.contains(
            `${classPrefix}--active`
        );

        if (isActive) {
            collapse();
        } else {
            expand();
        }

        $container.classList.toggle(`${classPrefix}--active`);
    });

    function expand() {
        // Measure the content height and apply it
        const bodyHeight = body.scrollHeight;
        body.style.height = bodyHeight + 'px';
        body.style.opacity = 1;
        body.style.marginTop = '12px';
    }

    function collapse() {
        // Fix current height, then animate to zero
        body.style.height = body.scrollHeight + 'px';
        requestAnimationFrame(() => {
            body.style.height = '0';

            body.style.opacity = 0;
            setTimeout(() => {
                body.style.marginTop = '0';
            }, 100);
        });
    }
}
